import {BaseModel} from "../../../../infrastructure/models/base-model";
import {DIDOMI_NOTICE} from "../../../consts";

export class DidomiConfigLanguageModel extends BaseModel {
  language: String;

  constructor(language: String) {
    super();

    this.language = language;
  }

  get enabled(): Array<String> {
    const enabled = [this.language || DIDOMI_NOTICE.defaultLanguage];

    return enabled
  }

  get default(): Array<String> {
    return this.language || DIDOMI_NOTICE.defaultLanguage;
  }

  getDidomiObject() {
    return {
      enabled: this.enabled,
      default: this.default
    }
  }
}